import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatError } from "../lib/auth";
import { Heart, ArrowLeft } from "lucide-react";

export default function Login() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email, password);
      nav(u.questionnaire ? "/home" : "/questionnaire");
    } catch (err) {
      setError(formatError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="app-shell bg-aurora min-h-screen px-7 pt-12 pb-10" data-testid="login-page">
      <Link to="/" className="inline-flex items-center gap-1 text-[#8A7E91] mb-8" data-testid="back-landing">
        <ArrowLeft size={18} strokeWidth={1.7} /> <span className="text-sm">Zpět</span>
      </Link>

      <div className="flex items-center gap-2 mb-8">
        <div className="w-10 h-10 rounded-2xl bg-gradient-to-br from-[#082A24] to-[#0F3D34] flex items-center justify-center shadow-lg">
          <Heart size={20} fill="white" strokeWidth={0} className="text-white" />
        </div>
        <span className="font-display text-2xl font-semibold text-[#332D38]">Sentra</span>
      </div>

      <h1 className="font-display text-4xl text-[#332D38] mb-2">Vítej zpět ❤️</h1>
      <p className="text-[#54635F] mb-8">Pokračuj tam, kde jsi skončil/a.</p>

      <form onSubmit={onSubmit} className="space-y-4">
        <div>
          <label className="label-soft">E-mail</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-field" placeholder="ty@email.cz" data-testid="login-email" />
        </div>
        <div>
          <label className="label-soft">Heslo</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-field" placeholder="••••••••" data-testid="login-password" />
        </div>

        {error && <div className="text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-2xl p-3" data-testid="login-error">{error}</div>}

        <button type="submit" disabled={loading} className="btn-primary mt-4" data-testid="login-submit">
          {loading ? "Přihlašuji..." : "Přihlásit se"}
        </button>
      </form>

      <p className="text-center text-sm text-[#8A7E91] mt-8">
        Nemáš účet?{" "}
        <Link to="/register" className="text-[#C9A66B] font-medium" data-testid="go-register">Zaregistruj se</Link>
      </p>
    </div>
  );
}
